import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { EconomicCalendarEvent } from "../../hooks/useEconomicCalendar";
import { IMPACT_COLORS } from "./economicCalendarSelection";

dayjs.extend(utc);

// How an economic event's fields read on screen — shared by the panel's row
// and the full calendar's card so a figure never formats two ways.

export const isFinitely = (value: number | null): value is number =>
  value != null && Number.isFinite(value);

// A missing figure is a dash, never a zero — a number is never presented as
// something it isn't.
export const formatEconomicValue = (
  value: number | null,
  unit: string | null,
): string => {
  if (!isFinitely(value)) return "—";
  return `${value}${unit ?? ""}`;
};

// FMP economic timestamps are UTC wall-clock; show the viewer's local time.
export const eventTime = (event: EconomicCalendarEvent): string =>
  dayjs.utc(event.date).local().format("HH:mm");

export const impactColorOf = (event: EconomicCalendarEvent): string => {
  if (
    event.impact === "High" ||
    event.impact === "Medium" ||
    event.impact === "Low"
  ) {
    return IMPACT_COLORS[event.impact];
  }
  return IMPACT_COLORS.Low;
};

export const displayCountry = (event: EconomicCalendarEvent): string =>
  event.country === "GB" ? "UK" : event.country;
